import type { NavigationTab } from '@/types'

const Routes: NavigationTab[] = [
  {
    tabName: 'clinical_ai_triage',
    to: '/solutions/triage',
    sections: [],
  },
  {
    tabName: 'who_we_help',
    sections: [
      {
        title: 'who_we_help',
        links: [
          {
            to: '/industries/public-health-and-government',
            title: 'government',
          },
          {
            to: '/industries/health-plans',
            title: 'insurers',
          },
          {
            to: '/industries/providers',
            title: 'providers',
          },
          {
            to: '/industries/telemedicine',
            title: 'telemedicine',
          },
        ],
      },
    ],
  },
  {
    tabName: 'trust_hub',
    sections: [
      {
        title: 'trust_hub',
        links: [
          {
            title: 'compliance',
            to: '/regulatory-compliance',
          },
          {
            title: 'publications',
            to: '/research-studies',
          },
          {
            title: 'case_studies',
            to: '/case-studies',
          },
          {
            title: 'resource_hub',
            to: '/reports',
          },
          {
            title: 'blog',
            to: '/blog',
          },
        ],
      },
    ],
  },
  {
    tabName: 'company',
    sections: [
      {
        title: 'connect_us',
        links: [
          {
            title: 'about',
            to: '/about',
          },
          {
            title: 'careers',
            to: '/careers',
          },
          {
            title: 'events',
            to: '/events',
          },
          {
            title: 'newsroom',
            to: '/newsroom',
          },
          {
            title: 'contact',
            to: '/contact',
          },
        ],
      },
    ],
  },
]

export default Routes
